import "/builds/private/pd-ssr/www/js/libs/select22.min.js"
import "/builds/private/pd-ssr/www/js/libs/select2_locale_ru.js"
import "/builds/private/pd-ssr/www/css/libs/select22.css"